/*
 * Copyright (c) Dito Technologies LLC
 */

const midiToLineIdxLookup: { [midi: number]: number | undefined } = {
    32: 27,
    33: 26,
    34: 26,
    35: 25,
    36: 24,
    37: 24,
    38: 23,
    39: 23,
    40: 22,
    41: 21,
    42: 21,
    43: 20,
    44: 20,
    45: 19,
    46: 19,
    47: 18,
    48: 17,
    49: 17,
    50: 16,
    51: 16,
    52: 15,
    53: 14,
    54: 14,
    55: 13,
    56: 13,
    57: 12,
    58: 12,
    59: 11,
    60: 10,
    61: 10,
    62: 9,
    63: 9,
    64: 8,
    65: 7,
    66: 7,
    67: 6,
    68: 6,
    69: 5,
    70: 5,
    71: 4,
    72: 3,
    73: 3,
    74: 2,
    75: 2,
    76: 1,
    77: 0,
    78: 0,
    79: -1,
    80: -1,
    81: -2,
    82: -2,
    83: -3,
    84: -4,
    85: -4,
    86: -5,
    87: -5,
    88: -6,
    89: -7
};

export default function MIDIToLineFromTrebleClef(midi: number): number | undefined {
    return midiToLineIdxLookup[midi];
}